import { BareActionContext } from 'vuex-typex'
import { StatementState } from '../state'
import { RootState } from '../..'
import statementStore from '../statement-store'

export default async function resetStatementForm(context: BareActionContext<StatementState, RootState>)
{
    statementStore.commitResetStatementForm({ })

    return
}
